module.exports = __webpack_public_path__ + "static/calm-hand-05bbca42da3171d864b18cfc0d190e32.webm";